import { render, staticRenderFns } from "./state-to-done.vue?vue&type=template&id=6772f290&scoped=true"
import script from "./state-to-done.vue?vue&type=script&lang=js"
export * from "./state-to-done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6772f290",
  null
  
)

export default component.exports